// extracted by mini-css-extract-plugin
module.exports = {"container":"switch_container__aRDfz","switch":"switch_switch__xCPrr","slider":"switch_slider__1kwVw","round":"switch_round__1PnI3"};